import { render, staticRenderFns } from "./purchaserAgent.vue?vue&type=template&id=38eeeb4e&scoped=true"
import script from "./purchaserAgent.vue?vue&type=script&lang=js"
export * from "./purchaserAgent.vue?vue&type=script&lang=js"
import style0 from "./purchaserAgent.vue?vue&type=style&index=0&id=38eeeb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eeeb4e",
  null
  
)

export default component.exports